import { LinearProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import WarningRoundedIcon from '@material-ui/icons/WarningRounded'
import { Elements } from '@tfo/common'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { ArchiveExportProgress } from './useArchiveExcelExport'

const { Label } = Elements

const useStyles = makeStyles({
    exportErrorBanner: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
        boxSizing: 'border-box',
        padding: '16px 20px',
        marginBottom: '16px',
        backgroundColor: '#FCF0F4',
        border: '1px solid #C2185B',
        borderRadius: '4px',
    },
    exportErrorBannerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        color: '#C2185B',
    },
    exportErrorBannerTitle: {
        fontWeight: 700,
        color: '#000',
        marginRight: '8px',
    },
    exportErrorBannerSubtitle: {
        color: '#767676',
    },
    exportProgressContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        width: '100%',
        marginBottom: '12px',
    },
    exportProgressBarRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        width: '100%',
    },
    exportProgressBar: {
        flexGrow: 1,
        height: '10px',
        borderRadius: '5px',
    },
    exportProgressBarColor: {
        backgroundColor: '#4caf50',
    },
})

interface ExcelExportStatusProps {
    exportError: boolean
    isExporting: boolean
    showProgressBar: boolean
    exportProgress: ArchiveExportProgress | null
}

const ExcelExportStatus = ({ exportError, isExporting, showProgressBar, exportProgress }: ExcelExportStatusProps) => {
    const style = useStyles()
    const intl = useIntl()

    return (
        <>
            {exportError &&
                <div className={style.exportErrorBanner}>
                    <div className={style.exportErrorBannerLeft}>
                        <WarningRoundedIcon />
                        <span>
                            <span className={style.exportErrorBannerTitle}>
                                {intl.formatMessage({ id: 'archived.report.export.error.title' })}
                            </span>
                            <span className={style.exportErrorBannerSubtitle}>
                                {intl.formatMessage({ id: 'archived.report.export.error.subtitle' })}
                            </span>
                        </span>
                    </div>
                </div>
            }
            {isExporting && showProgressBar && exportProgress &&
                <div className={style.exportProgressContainer}>
                    <Label>
                        {intl.formatMessage({ id: 'archived.report.export.inProgress' })}
                    </Label>
                    <div className={style.exportProgressBarRow}>
                        <LinearProgress
                            className={style.exportProgressBar}
                            classes={{ barColorPrimary: style.exportProgressBarColor }}
                            variant="determinate"
                            value={isFinite(exportProgress.total) && exportProgress.total > 0 ? (exportProgress.fetched / exportProgress.total) * 100 : 0} />
                        <Label>
                            {`${exportProgress.fetched} / ${exportProgress.total}`}
                        </Label>
                    </div>
                </div>
            }
        </>
    )
}

export default ExcelExportStatus
